import { render, staticRenderFns } from "./ProfileCard.htm?vue&type=template&id=78238037&scoped=true&"
import script from "./ProfileCard.ts?vue&type=script&lang=js&"
export * from "./ProfileCard.ts?vue&type=script&lang=js&"
import style0 from "./ProfileCard.scss?vue&type=style&index=0&id=78238037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78238037",
  null
  
)

export default component.exports